module.exports = __webpack_public_path__ + "Expedia_ico.png?d95844475b0e14f06db881f35ad01da8";